import { IonButton, IonIcon } from "@ionic/react";
import { personCircle } from "ionicons/icons";
import React from "react";
import "./styles.css";

interface UserMenuProps {
	visible: boolean;
	name?: string;
	email?: string;
	photoUrl?: string;
	onSignOut: () => void;
}

const UserMenu: React.FC<UserMenuProps> = ({
	visible = false,
	name = "",
	email = "",
	photoUrl = null,
	onSignOut,
}) => {
	if (!visible) return null;

	return (
		<div className="user-menu" onClick={(e) => e.stopPropagation()}>
			<div className="user-menu__arrow-up"></div>

			<div className="user-menu__icon">
				{!photoUrl && (
					<IonIcon
						slot="icon-only"
						style={{ fill: "#000000", fontSize: "48px" }}
						icon={personCircle}
					/>
				)}
				{photoUrl && (
					<img
						style={{ borderRadius: "50%", height: 48, width: 48 }}
						src={photoUrl!}
					/>
				)}
			</div>

			<div className="user-menu__data">
				<div className="user-menu__name">{name}</div>
				<div className="user-menu__email">{email}</div>
			</div>

			<div className="user-menu__separator"></div>

			{/* <div className="user-menu__sign-out">
        <IonButton
          id="logout-button"
          className="user-menu__sign-out__btn"
          fill="clear"
          onClick={onSignOut}
        >
          Cerrar sesión
        </IonButton>
      </div> */}
		</div>
	);
};

export default UserMenu;
